export default "__VITE_ASSET__De2QeHo8__"